/**
 * Uploader
 */
class Uploader {
    wrapElem;
    inputFileSelector;
    wrapBoxSelector;
    selectors;

    /**
     * Constructor
     * @param {HTMLElement} wrapElem
     * @param {String} inputFileSelector
     * @param {String} wrapBoxSelector
     */
    constructor({
        wrapElem,
        inputFileSelector = 'input[data-uploader-file]',
        wrapBoxSelector = '[data-uploader-box]',
    }) {
        this.wrapElem = wrapElem;
        this.inputFileSelector = inputFileSelector;
        this.wrapBoxSelector = wrapBoxSelector;
        this.selectors = {
            elemBar: 'progress-bar',
            elemBarItem: 'progress-bar__item',
        };

        this.render();
    }

    /**
     * Builder run
     * @param {Object} data
     * @returns {Uploader}
     */
    static run(data = {}) {
        return new Uploader(data);
    }

    /**
     * Show progress load
     * @param {String} name
     * @param {HTMLElement} box
     * @param {HTMLElement} target
     */
    static showProgressBar(name, box, target) {
        let width = 1;
        let id = setInterval(() => {
            if (width >= 100) {
                clearInterval(id);
                box.innerHTML = name;
            } else {
                width++;
                target.style.width = `${width}%`;
            }
        }, 10);
    }

    /**
     * Action on change input
     * @param {InputEvent} e
     */
    startAction = (e) => {
        let files = e.target.files;
        let filesName = '';
        let length = files.length - 1;

        for (let i = 0; i <= length; i++) {
            filesName += `<span class="check-icon"></span>&nbsp;${i + 1}. ${files[i].name}<br/>`;
        }

        const wrapBox = this.wrapElem.querySelector(this.wrapBoxSelector);

        if (wrapBox) {
            wrapBox.innerHTML = `<div class="${this.selectors.elemBar}"><div class="${this.selectors.elemBarItem}"></div></div>`;
            let targetElem = wrapBox.querySelector(`.${this.selectors.elemBarItem}`);

            if (targetElem) {
                Uploader.showProgressBar(filesName, wrapBox, targetElem);
            }
        }
    };

    /**
     * Listeners
     */
    setUpListeners() {
        let fileInput = this.wrapElem.querySelector(this.inputFileSelector);

        if (!fileInput) {
            return;
        }

        fileInput.addEventListener('change', this.startAction);
    }

    /**
     * Starter
     */
    render() {
        if (!this.wrapElem) {
            return;
        }

        this.setUpListeners();
    }
}

export default Uploader;
